import { CompaniesScope } from 'mormaii-web-presentation/companies'
import { CompanyConfirmScope } from 'mormaii-web-presentation/company-confirm'
import { CompanyEditScope } from 'mormaii-web-presentation/company-edit'
import type { ViewFactory } from 'wdc-cube-solid'

import { CompanyConfirmView } from './confirm/v-company-confirm'
import { CompanyEditView } from './edit/v-company-edit'
import { CompaniesView } from './v-companies'

/**
 * A listagem e os dois dialogos que se abrem por cima dela.
 *
 * Um registro so porque sao o mesmo conceito: em Empresas a listagem E a
 * aterrissagem, e editar e confirmar sao places FILHOS dela.
 */
export function registerViews(rv: typeof ViewFactory.register) {
    rv(CompaniesScope, CompaniesView)
    rv(CompanyEditScope, CompanyEditView)
    rv(CompanyConfirmScope, CompanyConfirmView)
}

export { CompaniesView, CompanyConfirmView, CompanyEditView }
